import { render } from "./Cvr.vue?vue&type=template&id=73b40e11"
import script from "./Cvr.vue?vue&type=script&lang=js"
export * from "./Cvr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__